import { render, staticRenderFns } from "./ViewCounselorModal.vue?vue&type=template&id=33998e09&scoped=true&"
import script from "./ViewCounselorModal.vue?vue&type=script&lang=js&"
export * from "./ViewCounselorModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewCounselorModal.vue?vue&type=style&index=0&id=33998e09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33998e09",
  null
  
)

export default component.exports